import React from 'react';
import ReactTooltip, { TooltipProps } from 'react-tooltip';

interface Props extends TooltipProps {
	className?: string;
}

const PlannerTooltip = (props: Props) => {
	const { className, ...otherProps } = props;

	return (
		<ReactTooltip className={className} {...otherProps} backgroundColor="#1A202C" textColor="white">
			{props.children}
		</ReactTooltip>
	);
};

export default PlannerTooltip;
